<template>
  <div>
    <ed-modelo :intTipoModeloId="1321" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdModelo from "@/components/lista/index";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: { EdModelo },
  mounted() {
  },
  beforeDestroy() {
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>
